import { supabase } from '@/lib/supabase';
import { apiFetch } from '@/lib/api';

interface BootstrapResponse {
  user_id: string;
  email: string;
  full_name: string | null;
  workspaces: { workspace_id: string; name: string; timezone: string; role: 'owner' | 'agent'; created_at: string }[];
}

export function useAuth() {
  return {
    async signIn(email: string, password: string) {
      const { error } = await supabase.auth.signInWithPassword({ email, password });
      if (error) throw error;
      return apiFetch<BootstrapResponse>('/api/auth/bootstrap', { method: 'POST' });
    },
    async signOut() {
      await supabase.auth.signOut();
      localStorage.removeItem('zaptor:active_workspace_id');
    },
    async resetPassword(email: string) {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/reset-password`
      });
      if (error) throw error;
    }
  };
}
